<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <template v-for="li in menu">
          <li
            v-if="!li.permissions || checkAccess(li)"
            :key="li.name"
            :class="`nav-item ${li.children ? 'nav-dropdown' : ''}`"
          >
            <router-link v-if="!li.children" :to="li.url" class="nav-link">
              <i :class="li.icon" /> {{ li.name }}
            </router-link>

            <template v-else>
              <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                <i :class="li.icon" /> {{ li.name }}
              </div>

              <ul class="nav-dropdown-items">
                <template v-for="nestedLi in li.children">
                  <li v-if="checkNestedAccess(nestedLi, li)" :key="nestedLi.name" class="nav-item">
                    <router-link :to="nestedLi.url" class="nav-link">
                      <i :class="nestedLi.icon" /> {{ nestedLi.name }}
                    </router-link>
                  </li>
                </template>
              </ul>
            </template>
          </li>
        </template>
        <li key="signout" class="nav-item">
          <a href="#" class="nav-link" @click.prevent="signOut">
            <i class="fa fa-sign-out" /> Sign out
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import _ from 'lodash';
import { menu } from '../helpers/menu';

export default {
  name: 'Sidebar',

  data: () => ({
    menu,
  }),

  computed: {
    userPermissions() {
      return this.$store.getters['user/getPermissions'];
    },
  },

  methods: {
    checkAccess(li) {
      let permissionsArr = li.permissions || [];
      if (li.children) {
        for (let i = 0; i < li.children.length; i += 1) {
          if (li.children[i].permissions) {
            permissionsArr = permissionsArr.concat(li.children[i].permissions);
          }
        }
      }
      if (!permissionsArr.length) return true;
      const xorPermissions = _.xor(permissionsArr, this.userPermissions.map(item => item.id));
      return xorPermissions.length !== permissionsArr.length + this.userPermissions.length;
    },
    checkNestedAccess(li, parentLi) {
      let permissionsArr = li.permissions || [];
      if (parentLi.permissions) permissionsArr = permissionsArr.concat(parentLi.permissions);
      if (!permissionsArr.length) return true;
      const xorPermissions = _.xor(permissionsArr, this.userPermissions.map(item => item.id));
      return xorPermissions.length !== permissionsArr.length + this.userPermissions.length;
    },
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    signOut() {
      localStorage.setItem('tokenStorage', '');
      this.$store.commit('user/storeAccessToken', '');
      this.$store.commit('user/setInfo', '');
      window.location.href = '/#/login';
    },
  },
};
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?07e73c40